module.exports = __webpack_public_path__ + "static/img/img-change-default-pwd.281d1823.png";